import CustomDateField from "components/CustomDateField";
import React from "react";
import {
  Datagrid,
  Filter,
  TextField,
  SearchInput,
  FunctionField,
  ListProps,
  SelectInput,
} from "react-admin";
import StatusField from "components/StatusField";
import { statusList } from "./const";
import ListWrapper from "../../components/ListWrapper";
import ListShowButton from "../../components/ListShowButton";
import ActionsMenu from "../../components/ActionsMenu";

const SubcontractorFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput label="Status" source="Status" choices={statusList} alwaysOn />
  </Filter>
);

const SubcontractorList = (props: ListProps) => {
  const breadcrumb = [{ link: "/subcontractors", title: "Subcontractors" }];

  return (
    <>
      <ListWrapper
        breadcrumb={breadcrumb}
        headerTitle="Subcontractors"
        isNotHaveSchoolFilter
        denseMode
        {...props}
        exporter={false}
        hasCreate={false}
        filters={<SubcontractorFilter />}
        bulkActionButtons={false}
      >
        <Datagrid rowClick="show">
          <TextField source="id" emptyText="-" />
          <TextField
            source="subcontractorIdentifier"
            label="Subcontractor Identifier"
            emptyText="-"
          />
          <TextField
            source="mbcVendorId"
            label="Subcontractor MBC Code"
            emptyText="-"
          />
          <TextField source="name" emptyText="-" />
          <TextField source="email" emptyText="-" />
          <TextField source="contactNumber" emptyText="-" />
          <CustomDateField source="createdAt" label="Created On" isDateTime />
          <StatusField source="status" />
          <FunctionField
            label="Actions"
            render={(record: any) => (
              <ActionsMenu render={[<ListShowButton record={record} />]} />
            )}
          />
        </Datagrid>
      </ListWrapper>
    </>
  );
};

export default SubcontractorList;
